module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/store_images/3_14916935eae579b99e9d99e5c0012dac.png";